import index from "./salbarzuvlul.vue";
export default index;
